import { render, staticRenderFns } from "./ContactsContentDesktop.vue?vue&type=template&id=c0848f2e&"
import script from "./ContactsContentDesktop.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ContactsContentDesktop.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0848f2e')) {
      api.createRecord('c0848f2e', component.options)
    } else {
      api.reload('c0848f2e', component.options)
    }
    module.hot.accept("./ContactsContentDesktop.vue?vue&type=template&id=c0848f2e&", function () {
      api.rerender('c0848f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/contacts/components/ContactsContentDesktop.vue"
export default component.exports